import { useCallback, useEffect, useState } from "react";
import { becomeASeller } from "../../redux/actions";
import BreadcrumbImage from "./BreadcrumbImage";
import WhyBecomeSeller from "./WhyBecomeSeller";
import CounterSection from "./CounterSection";
import StepsSection from "./StepsSection";
import TestimonialOne from "./TestimonialOne";

const BecomeASeller = () => {
    const [sellerData, setSellerData] = useState({});

    const fetchSellerData = useCallback(async () => {
        const data = await becomeASeller();

        if (data?.page?.data?.en) {
            setSellerData(data?.page?.data?.en);
        }
    }, []);

    useEffect(() => {
        fetchSellerData();
    }, [fetchSellerData]);

    return (
        <>
            {sellerData && (
                <>
                    <BreadcrumbImage sellerData={sellerData} />
                    <WhyBecomeSeller sellerData={sellerData} />
                    <CounterSection sellerData={sellerData} />
                    <StepsSection sellerData={sellerData} />                
                    <TestimonialOne sellerData={sellerData} />                
                </>
            )}
        </>
    );
};

export default BecomeASeller;
